'use client';

import { useRef } from 'react';
import classNames from '@/utils/classNames';
import usePixelWipe from '@/components/PixelWipeLoader/usePixelWipe';
import styles from './PixelReveal.module.css';

import type { HTMLAttributes } from 'react';

type PixelRevealProps = HTMLAttributes<HTMLDivElement> & {
  durationMs?: number;
  /** Cell coarseness as a fraction of width (bigger = chunkier pixels). */
  size?: number;
  /** Hold until the boot splash clears (default true). Set false where no splash runs (e.g. error screens). */
  waitForBootSplash?: boolean;
};

// Wraps decorative content and pixel-reveals it once the boot splash clears (immediately on soft
// navigations, where no splash runs). Applies the clip to its own box — wrap the visible/cropped
// CONTAINER, not a transformed child, for it to align.
export default function PixelReveal({
  children,
  className,
  durationMs,
  size,
  waitForBootSplash = true,
  ...rest
}: PixelRevealProps) {
  const ref = useRef<HTMLDivElement>(null);
  const revealed = usePixelWipe(ref, {
    type: 'reveal',
    durationMs,
    size,
    waitForBootSplash,
  });

  return (
    <div
      ref={ref}
      {...rest}
      className={classNames(className, !revealed && styles.hidden)}
    >
      {children}
    </div>
  );
}
